var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14513 1.9301L0.910133 9.0001C0.822817 9.15131 0.776616 9.32275 0.776127 9.49736C0.775638 9.67197 0.820878 9.84367 0.907346 9.99537C0.993814 10.1471 1.1185 10.2735 1.26899 10.362C1.41948 10.4506 1.59053 10.4982 1.76513 10.5001H10.2351C10.4097 10.4982 10.5808 10.4506 10.7313 10.362C10.8818 10.2735 11.0065 10.1471 11.0929 9.99537C11.1794 9.84367 11.2246 9.67197 11.2241 9.49736C11.2236 9.32275 11.1774 9.15131 11.0901 9.0001L6.85513 1.9301C6.766 1.78316 6.64049 1.66166 6.49073 1.57734C6.34097 1.49303 6.172 1.44873 6.00013 1.44873C5.82826 1.44873 5.6593 1.49303 5.50953 1.57734C5.35977 1.66166 5.23427 1.78316 5.14513 1.9301Z",
    stroke: "#BE202F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.5V6.5",
    stroke: "#BE202F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H6.00583",
    stroke: "#BE202F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.f133ae3aa70a6dd594732aacb895beec.svg";
export { ForwardRef as ReactComponent };